import type { SubstitutionPlanValidation } from "@msuite/utils/substitutions";
import { createContext, useContext } from "react";

/** Interface */
interface ISubstitutionPlanFormContext {
	getItemIndex: (itemId: string) => number;
	absenceId: string;
	startDate: string;
	endDate: string;
	validation: SubstitutionPlanValidation;
}

/** Context */
export const SubstitutionPlanFormContext = createContext<ISubstitutionPlanFormContext>(
	{} as ISubstitutionPlanFormContext,
);

/** Hooks */
export function useSubstitutionPlanFormContext() {
	return useContext(SubstitutionPlanFormContext);
}
